import { useContext, useEffect, useState } from "react";
import { Colorcontext } from "../../../Component/Colorcontext/ColorContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HttpClient from "../../../utils/HttpClient";
import "../../CardMember/Style.css"
import { useSelector } from 'react-redux'
import SubscriptionPlans from "../components/SubscriptionPlans";

const ContactInformation = ({ onNext, subscriptionId }) => {
  const colordata = useContext(Colorcontext);
  const location = useLocation();
  const navigate = useNavigate();
  const { UserProfileID } = useSelector((state) => state.app);
  const [selectedPlan, setSelectedPlan] = useState({ _id: "", name: "", plan: "" });
  const [plans, setPlans] = useState([]);
  const [country, setCountry] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [company, setCompany] = useState([]);
  const [countryState, setCountryState] = useState([]);
  const [formData, setFormData] = useState({
    profileTypeID: "",
    userName: UserProfileID?.userName || "",
    // password: UserProfileID?.password,
    personName: UserProfileID?.personName || "",
    designationID: UserProfileID?.designationID || "",
    phone_code: UserProfileID?.phone_code || "+971",
    countryCodePhone: UserProfileID?.phone_code || "+971",
    telephoneNo: UserProfileID?.telephoneNo || "",
    countryCodeMobile: UserProfileID?.phone_code || "+971",
    mobileNo: UserProfileID?.mobileNo || "",
    emirate: UserProfileID?.emirate || "",
    country: UserProfileID?.country,
    companyName: UserProfileID?.companyName || "",
    companyTypeID: UserProfileID?.companyTypeID || "",
    websiteLink: UserProfileID?.websiteLink || "",
    emailId: UserProfileID?.emailId,
    companyTypeName: UserProfileID?.companyTypeName,
    subscriptionId: subscriptionId
  });
  const [errors, setErrors] = useState({});
  const [profileTypes, setProfileTypes] = useState([])

  useEffect(() => {
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  useEffect(() => {
    if (!UserProfileID) {
      navigate("/");
    }
    getProfileType()
    getCountry();
    getState();
    getCompanyType();
    getDesignation();
    getPlan();
  }, []);

  useEffect(() => {
    getState();
  }, [formData.country]);

  const getProfileType = async () => {
    const response = await HttpClient.requestData("profile-type", "GET", "");
    if (response?.status) {
      setProfileTypes(response.data);
      const company = response.data.find(item => item.name === "Company");
      const id = company ? company._id : null;
      setFormData(prev => ({ ...prev, profileTypeID: id }));
    } else {
      console.log("Error while fetching designation data");
    }
  };

  const getCompanyType = async () => {
    const response = await HttpClient.requestData("companyType", "GET", "");
    if (response.status) {
      setCompany(response.data);
    } else {
      console.log("Error while fetching company data");
    }
  };

  const getCountry = async () => {
    const response = await HttpClient.requestData("countries", "GET", {});
    if (response && response?.status) {
      setCountry(response?.data);
    }
  };

  const getState = async () => {
    const response = await HttpClient.requestData("countrywise-state/" + formData.country, "GET", {});
    if (response && response?.status) {
      setCountryState(response?.data?.[0]?.states);
    }
  };

  const getDesignation = async () => {
    const response = await HttpClient.requestData("designation", "GET", "");
    if (response?.status) {
      setDesignation(response.data);
    } else {
      console.log("Error while fetching designation data");
    }
  };

  const getPlan = async () => {
    const response = await HttpClient.requestData("subscription-plans", "GET", "");
    if (response && response.status) {
      setPlans(response?.data.reverse());
      addSubscriptionId(response?.data);
    } else {
      console.log("Error from getting subscription:", response);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    addCompanyTypeName(name, value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    validateField(name, value);
  };

  const addCompanyTypeName = (name, value) => {
    if (name == "companyTypeID") {
      if (company.length == 0) {
        return false;
      }
      const companyType = company.find(item => item._id === value);
      const companyTypeName = companyType ? companyType.type : '';
      if (companyTypeName) {
        setFormData((prevData) => ({
          ...prevData,
          ["companyTypeName"]: companyTypeName,
        }));
      }
    }
  }

  const addSubscriptionId = (plans) => {
    if (plans == undefined) {
      return false;
    }
    if (!subscriptionId) {
      const defaultPlan = plans.find(item => item.plan === "Basic");
      setSelectedPlan(defaultPlan);
      setFormData((prevData) => ({
        ...prevData,
        ["subscriptionId"]: defaultPlan ? defaultPlan?._id : '',
      }));
    } else {
      const defaultPlan = plans.find(item => item._id === subscriptionId);
      setSelectedPlan(defaultPlan);
      setFormData((prevData) => ({
        ...prevData,
        ["subscriptionId"]: defaultPlan ? defaultPlan?._id : '',
      }));
    }
  }

  const validateField = (fieldName, value) => {
    let error = "";
    switch (fieldName) {
      case "mobileNo":
        if (!value) error = "Mobile number is required";
        else if (!/^\d{10}$/.test(value))
          error = "Mobile number must be 10 digits";
        break;
      case "emirate":
        if (!value) error = "Emirate is required";
        break;

      default:
        break;
    }
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
  };

  const requiredFields = [
    { fieldID: "personName", fieldName: "Full name" },
    { fieldID: "designationID", fieldName: "Designation" },
    { fieldID: "mobileNo", fieldName: "Mobile number" },
    { fieldID: "companyName", fieldName: "Company Name" },
    { fieldID: "companyTypeID", fieldName: "Type of Business" },
    { fieldID: "emailId", fieldName: "Work email" },
    { fieldID: "emirate", fieldName: "State" },
    { fieldID: "country", fieldName: "Country" },
  ];

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Check required fields
    requiredFields.forEach((field) => {
      if (!formData[field.fieldID]) {
        newErrors[field.fieldID] = `${field.fieldName} is required`;
        isValid = false;
      }
    });

    // Validate email format
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      newErrors.emailId = "Invalid email format";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const updatedFormData = {
      ...formData,
      phone_code: formData.countryCodeMobile,
    };
    // let cleanedData;
    // if (updatedFormData.profileTypeID === "65df70ab31670c8a6a8c5d76") {
    //   const { companyName, companyTypeID, countryCodeMobile, countryCodePhone, ...rest } = updatedFormData;
    //   cleanedData = rest;
    // } else {
    //   const { countryCodeMobile, countryCodePhone, ...rest } = updatedFormData;
    //   cleanedData = rest;
    // }

    if (validateForm()) {
      await HttpClient.requestData("update-contact-info", "PUT", updatedFormData);
      onNext();
    } else {
      console.log("Error");
    }
  };

  return (
    <>
      <section className="wizrd-item-section">
        <div className="wizrd-item-container">
          <div className="_listbusinessdivflx">
            <div className="_listbusinessdivleft">

              <div className="listbusinessdivleftbg">
                <p className="conattaindptxtpp">Contact information</p>

                <div className="contatcindofdicfplx">

                  <div className="contatcindofdiinpur" style={{ maxWidth: "100%" }}>
                    <SubscriptionPlans
                      plans={plans}
                      setSelectedPlan={setSelectedPlan}
                      selectedPlan={selectedPlan}
                    />
                  </div>

                  <div className="contatcindofdiinpur" style={{ maxWidth: "100%" }}>
                    <p className="contatcindofdiinpurtxtp">
                      Profile type <span> *</span>
                    </p>
                    <select className="neooSelect"
                      name="profileTypeID"
                      value={formData.profileTypeID}
                      onChange={handleInputChange}
                      disabled={true}
                    >
                      <option value="">Choose...</option>
                      {
                        profileTypes?.map((item) => {
                          return (
                            <><option value={item._id} key={item._id}>{item.name}</option></>
                          )
                        })
                      }
                    </select>
                    {errors.profileTypeID && (
                      <span className="error">{errors.profileTypeID}</span>
                    )}
                  </div>


                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Full name <span>*</span>
                    </p>
                    <input
                      type="text"
                      name="personName"
                      value={formData.personName}
                      onChange={handleInputChange}
                      placeholder="John Doe"
                      className="neooTextbox"
                    />
                    {errors.personName && (
                      <span className="error">{errors.personName}</span>
                    )}
                  </div>

                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Designation <span> *</span>
                    </p>

                    <select className="neooSelect"
                      name="designationID"
                      value={formData.designationID}
                      onChange={handleInputChange}
                    >
                      <option value="">Choose...</option>
                      {
                        designation?.map((item) => {
                          return (
                            <><option value={item._id}>{item.designation}</option></>
                          )
                        })
                      }
                    </select>

                    {errors.designationID && (
                      <span className="error">{errors.designationID}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">Tel number</p>
                    <div className="input-wrapper">
                      <select
                        className="_form-control _countrycodebox inpustxocntbusuitxtpp"
                        aria-label="Default select example"
                        name="countryCodePhone"
                        style={{
                          width: "30%",
                          background: "#fff",
                        }}
                        value={formData.countryCodePhone}
                        onChange={handleInputChange}
                      >
                        {country.map((item, i) => (
                          <option key={i} value={item?.phone_code}>
                            {item?.emoji} {item?.phone_code}
                          </option>
                        ))}
                      </select>
                      <input
                        // type="number"
                        name="telephoneNo"
                        value={formData.telephoneNo}
                        onChange={handleInputChange}
                        placeholder="Tel number"
                        className="inpustxocntbusuitxtpp"
                        style={{
                          width: "70%"
                        }}
                      />
                    </div>
                    {errors.telephoneNo && (
                      <span className="error">{errors.telephoneNo}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Mobile number<span> *</span>
                    </p>
                    <div className="input-wrapper">
                      <select
                        className="_form-control _countrycodebox inpustxocntbusuitxtpp"
                        aria-label="Default select example"
                        name="countryCodeMobile"
                        style={{
                          width: "30%",
                          background: "#fff",
                        }}
                        value={formData.countryCodeMobile || "+971"}
                        onChange={handleInputChange}
                      >
                        {country.map((item, i) => (
                          <option key={i} value={item?.phone_code}>
                            {item?.emoji} {item?.phone_code}
                          </option>
                        ))}
                      </select>
                      <input
                        name="mobileNo"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        placeholder="Mobile number"
                        className="inpustxocntbusuitxtpp"
                        style={{
                          width: "70%"
                        }}
                      />
                    </div>
                    {errors.mobileNo && (
                      <span className="error">{errors.mobileNo}</span>
                    )}
                  </div>

                  {
                    formData.profileTypeID === "65ddc3d1d569c29c97f6082c" && (
                      <>
                        <div className="contatcindofdiinpur">
                          <p className="contatcindofdiinpurtxtp">
                            Company name <span> *</span>
                          </p>
                          <input
                            type="text"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            placeholder="Company name"
                            className="neooTextbox"
                          />
                          {errors.companyName && (
                            <span className="error">{errors.companyName}</span>
                          )}
                        </div>
                        <div className="contatcindofdiinpur">
                          <p className="contatcindofdiinpurtxtp">
                            Type of business <span> *</span>
                          </p>
                          <select className="neooSelect"
                            name="companyTypeID"
                            value={formData.companyTypeID}
                            onChange={handleInputChange}
                          >
                            <option value="">Choose...</option>
                            {
                              company?.map((item) => {
                                return (
                                  <><option value={item._id}>{item.type}</option></>
                                )
                              })
                            }
                          </select>

                          {errors.companyTypeID && (
                            <span className="error">{errors.companyTypeID}</span>
                          )}

                        </div>
                      </>
                    )
                  }



                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Email address <span> *</span>
                    </p>
                    <input
                      type="text"
                      name="emailId"
                      value={formData.emailId}
                      // onChange={handleInputChange}
                      placeholder="info@companyname.com"
                      className="_inpustxocntbusuitxtpp neooTextbox"
                      readOnly={true}
                    />
                    {errors.emailId && (
                      <span className="error">{errors.emailId}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Website <span> </span>
                    </p>
                    <input
                      type="text"
                      name="websiteLink"
                      value={formData.websiteLink}
                      onChange={handleInputChange}
                      placeholder="www.webname.com"
                      className="neooTextbox"
                    />
                  </div>

                  {/* <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Location <span> </span>
                    </p>
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      placeholder="Palm Jumeirah"
                      className="inpustxocntbusuitxtpp"
                    />
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Address <span> *</span>
                    </p>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      placeholder="Jumeirah tower #123, D block"
                      className="inpustxocntbusuitxtpp"
                    />
                    {errors.address && (
                      <span className="error">{errors.address}</span>
                    )}
                  </div> */}

                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Country <span> *</span>
                    </p>
                    <select className="neooSelect"
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>Choose...</option>
                      {
                        country
                          .map((item, key) => {
                            return (
                              <><option value={item?._id}>{item?.name}</option></>
                            )
                          })
                      }
                      {/* <option value="United Arab Emirate">United Arab Emirate</option> */}
                    </select>
                  </div>

                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      State <span> *</span>
                    </p>
                    <select className="neooSelect"
                      name="emirate"
                      value={formData.emirate}
                      onChange={handleInputChange}
                    >
                      <option value="">Choose...</option>
                      {
                        countryState?.map((item) => {
                          return (
                            <><option value={item.name}>{item.name}</option></>
                          )
                        })
                      }
                    </select>
                    {errors.emirate && (
                      <span className="error">{errors.emirate}</span>
                    )}
                  </div>


                  {/* <div className="contatcindofdiinpurnewalasda">
                    <p className="contatcindofdiinpurtxtp">
                      Location map <span> </span>
                    </p>
                    <input
                      type="text"
                      placeholder="United arab emirate"
                      className="inpustxocntbusuitxtpp"
                    />
                  </div> */}
                </div>

                <div className="btnnexttdivbtndivmain">
                  <Link
                    onClick={handleSubmit}
                    className="btnnexttdivbtn"
                  >
                    Next
                  </Link>
                </div>
              </div>

            </div>
            <div className="listbusinessdivrightt"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInformation;
